<template>
  <v-dialog
    v-model="dialog"
    max-width="1000px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            small
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-history
            </v-icon>
          </v-btn>
        </template>
        <span>View Dependent History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="dependentName + ' (' + dependentRelation.name +')'"
      text="List of Employee Dependent's Histories (Previous year tax relief record)"
      class="mb-0"
    >
      <v-row class="py-0 mb-n6">
        <v-col>
          <span class="font-weight-bold font-16">
            Histories
          </span>
          <employee-profile-general-info-dependent-history-dialog-create
            v-if="$hasPermissionTo(['update dependents']) && !isMyProfile && !isResigned"
            :dependent-id="dependentId"
            :dependent-relation="dependentRelation"
            @updated="loadData()"
          />
        </v-col>
      </v-row>
      <v-data-table
        :headers="dependentHistoryHeaders"
        :items="dependentHistories"
        disable-pagination
        hide-default-footer
        dense
        class="mt-5 mb-0"
        :style="`border:1px solid rgba(0,0,0,.12)`"
      >
        <template v-slot:item.status="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.relation_status.name }}
            </span>
          </div>
        </template>

        <template v-slot:item.education_level="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ !item.education_level || item.education_level === 'null' ? 'N/A' : item.education_level }}
            </span>
          </div>
        </template>

        <template v-slot:item.is_disabled="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.is_disabled ? 'Yes' : 'No' }}
            </span>
          </div>
        </template>

        <template v-slot:item.start_year="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.start_year }}
            </span>
          </div>
        </template>

        <template v-slot:item.end_year="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.end_year ? item.end_year : 'N/A' }}
            </span>
          </div>
        </template>

        <template 
          v-slot:item.action="{ item }"
        >
          <div style="white-space:nowrap">
            <employee-profile-general-info-dependent-history-dialog-edit
              v-if="$hasPermissionTo(['update dependents']) && !isMyProfile && !isResigned"
              :dependent-history="item"
              @updated="loadData()"
            />
            <employee-profile-general-info-dependent-history-dialog-delete
              v-if="$hasPermissionTo(['update dependents']) && !isMyProfile && !isResigned"
              :dependent-history="item"
              @deleted="loadData()"
            />
          </div>
        </template>
      </v-data-table>
    </material-card> 
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoDependentHistoryDialogCreate: () => import('@/components/hris/employee/profile/general-info/dependent/history/DialogCreate'),
      EmployeeProfileGeneralInfoDependentHistoryDialogEdit: () => import('@/components/hris/employee/profile/general-info/dependent/history/DialogEdit'),
      EmployeeProfileGeneralInfoDependentHistoryDialogDelete: () => import('@/components/hris/employee/profile/general-info/dependent/history/DialogDelete'),
    },
    props: {
      dependentId: {
        type: Number,
        required: true,
      },
      dependentName: {
        type: String,
        default: '',
      },
      dependentRelation: {
        type: Object,
        required: true,
      },
      dependentHistories: {
        type: Array,
        default: null,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headings: [
          {
            text: 'Status', 
            sortable: false, 
            value: 'relation_status.name',
            divider: true,
          },
          {
            text: 'Education Level', 
            sortable: false, 
            value: 'education_level',
            divider: true,
          },
          {
            text: 'Tax Relief (%)', 
            sortable: false, 
            value: 'tax_relief_percentage',
            divider: true,
            align: 'center',
          },
          {
            text: 'Disable?', 
            sortable: false, 
            value: 'is_disabled',
            divider: true,
          },
          {
            text: 'Payroll Start Year',
            sortable: false,
            value: 'start_year',
            divider: true,
            align: 'center',
          },  
          {
            text: 'Payroll End Year', 
            sortable: false, 
            value: 'end_year',
            divider: true,
            align: 'center',
          },                   
        ],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      dependentHistoryHeaders () {
        let originalTab = [...this.headings]
        if (this.$hasPermissionTo(['update dependents']) && !this.isMyProfile && !this.isResigned) {
          originalTab.splice(originalTab.length, 0, {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
            width: 100,
          })
        }

        return originalTab
      },
    },
    methods: {
      loadData () {
        this.$emit('updated')
      },
    },
  }
</script>

<style scoped>
  .font-16{
    font-size:16px;
  }
</style>
